var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackendIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1,38h126V2H1V38z M9,10h110v20H9V10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,82h126V46H1V82z M9,54h110v20H9V54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,127h126V91H1V127z M9,99h110v20H9V99z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 8,
    width: 8,
    x: 15,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    height: 8,
    width: 8,
    x: 31,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    height: 8,
    width: 8,
    x: 47,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    height: 8,
    width: 8,
    x: 15,
    y: 59
  }), /*#__PURE__*/React.createElement("rect", {
    height: 8,
    width: 8,
    x: 31,
    y: 59
  }), /*#__PURE__*/React.createElement("rect", {
    height: 8,
    width: 8,
    x: 47,
    y: 59
  }), /*#__PURE__*/React.createElement("rect", {
    height: 8,
    width: 8,
    x: 15,
    y: 105
  }), /*#__PURE__*/React.createElement("rect", {
    height: 8,
    width: 8,
    x: 31,
    y: 105
  }), /*#__PURE__*/React.createElement("rect", {
    height: 8,
    width: 8,
    x: 47,
    y: 105
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackendIcon);
export default __webpack_public_path__ + "static/media/backend_icon.4f37d189ee453502324621bfc327eb5c.svg";
export { ForwardRef as ReactComponent };